import {Card, Flex, Skeleton, theme, Typography} from 'antd';
import {getGMMemmberRewardsInfo} from 'Redux/Slices/gmMemberRewards';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useSnackBar} from 'Hooks';
import SnackBar from 'Components/SnackBar';

const MemberAccountInfo = (props) => {
  const {token} = theme.useToken();
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const [memberAccountInfo, setmemberAccountInfo] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);

  const dispatch = useDispatch();

  useEffect(() => {
    getMemberAccountInfo();
  }, [props.updateAccount]);

  const getMemberAccountInfo = async () => {
    try {
      const data1 = {externalRefId: selectedMember?.focusedMemberDetails?.externalRefId};
      let response = await dispatch(getGMMemmberRewardsInfo(data1)).unwrap();
      const {data, loading, error} = response;
      _handleResponse(data, loading, error);
    } catch (error: any) {
      console.error(error);
      return error;
    }
  };

  const _handleResponse = (data, loading, error) => {
    setLoading(loading);
    error && setError(error.message);
    if (data) {
      setmemberAccountInfo(data?.memberAccountInfo);
    }
  };

  const numberWithCommas = (x: number): string => {
    if (x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }
    return '0';
  };
  return (
    <>
      {loading ? (
        <Skeleton active avatar paragraph={{rows: 2}} />
      ) : error ? (
        <SnackBar
          errorMessage={error}
          closeSnackBar={closeSnackBar}
          isSnackBarOpen={isSnackBarOpen}
        />
      ) : (
        <Flex gap={12} wrap>
          <Card size="small" styles={{body: {padding: '12px 16px', minWidth: 160}}}>
            <Typography.Text
              style={{
                fontSize: 11,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                fontWeight: 600,
                color: token.colorTextTertiary,
              }}>
              Available points
            </Typography.Text>
            <div style={{fontSize: 20, fontWeight: 700, marginTop: 4}}>
              {numberWithCommas(memberAccountInfo?.redeemablePoints)}
            </div>
          </Card>
          <Card size="small" styles={{body: {padding: '12px 16px', minWidth: 160}}}>
            <Typography.Text
              style={{
                fontSize: 11,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                fontWeight: 600,
                color: token.colorTextTertiary,
              }}>
              Available cash balance
            </Typography.Text>
            <div style={{fontSize: 20, fontWeight: 700, marginTop: 4}}>
              ${numberWithCommas(memberAccountInfo?.redeemableDollars)}/$
              {numberWithCommas(memberAccountInfo?.capDollars)}
            </div>
          </Card>
        </Flex>
      )}
    </>
  );
};

export default MemberAccountInfo;
